import { render, staticRenderFns } from "./Reactivate.vue?vue&type=template&id=cbfa6a16&"
import script from "./Reactivate.vue?vue&type=script&lang=js&"
export * from "./Reactivate.vue?vue&type=script&lang=js&"
import style0 from "./Reactivate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports